/*
 * Shared styles for the video-package files.
 */

export const heightOfVideoplayerControls = 40;
